// T-36 — „Kontakt aus markierter Signatur": Was wird aus einer Markierung im
// Mailtext angeboten? Rein und ohne DOM, damit die Regeln testbar sind.

/** Höchstlänge des Textes, der an den Parser geht (Backend-DTO: 4000). */
export const MARKIERUNG_MAX_ZEICHEN = 4000;
/** Kürzere Markierungen (ein Buchstabe, ein Doppelklick auf „am") lösen nichts aus. */
export const MARKIERUNG_MIN_ZEICHEN = 3;

/** Was der Markierung angeboten wird — `null` heißt: nichts anbieten. */
export type MarkierungsAngebot = { text: string };

/**
 * Text einer Markierung aufbereiten: Zeilenenden vereinheitlichen, Zeilen
 * rechts trimmen, mehrere Leerzeilen zu einer zusammenfassen, außen trimmen und
 * auf {@link MARKIERUNG_MAX_ZEICHEN} kappen. Leere oder zu kurze Auswahl → `null`.
 */
export function angebotFuer(roh: string | null | undefined): MarkierungsAngebot | null {
    const text = String(roh ?? "")
        .replace(/\r\n?/g, "\n")
        .replace(/ /g, " ")
        .split("\n")
        .map((z) => z.replace(/\s+$/, ""))
        .join("\n")
        .replace(/\n{3,}/g, "\n\n")
        .trim()
        .slice(0, MARKIERUNG_MAX_ZEICHEN);
    if (text.length < MARKIERUNG_MIN_ZEICHEN) return null;
    return { text };
}
